export default function PHP_headers_list() {
  return (
    <div>
      <h1>PHP_headers_list</h1>
    </div>
  );
}
